import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Redirect, Route} from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import Data from "./Data";

class ModalEditClassInfo extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            fields : {
                namefamily : this.props.products['studentname'],
                phone : this.props.products['studentphone']
            },
            errors : {

            }
        }

    }

    componentDidMount() {

    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        fields[target.name] = target.value;
        this.setState({fields});
    }

    handleSubmit(event){

        event.preventDefault();

        this.handleValidation((valid)=>{
            if (valid){
                $('#'+this.props.id).modal('hide');
                this.handleRequest();
            } else {
                const {errors} = this.state;

                if (errors['no'] !== null ){
                    this.props.toast(errors['no'],3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    })
                }
                if (errors['namefamily'] !== null ){
                    this.props.toast(errors['namefamily'],3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    })
                }
                if (errors['phone'] !== null ){
                    this.props.toast(errors['phone'],3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    })
                }
            }
        })

    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = this.state.errors;
        let formIsValid = true;
        console.log("handleValidation");

        if (fields.name === this.props.products['studentname'] &&
            fields.phone === this.props.products['studentphone']){
            formIsValid = false;
            errors['no'] = 'لطفا یکی از فیلدها را تغییر دهید!';
        }else {
            errors['no'] = null;
        }
        if (fields.namefamily === ""){
            formIsValid = false;
            errors['namefamily'] = 'لطفا نام نام خانوادگی هنرجو را وارد کنید!';
        }else {
            errors['namefamily'] = null;
        }
        
        if (fields.phone === ""){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن هنرجو را وارد کنید!';
        }else {
            errors['phone'] = null;
        }

        if (!fields.phone.startsWith('09')){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!';
        }else if (fields.phone.startsWith('09')){
            errors['phone'] = null;
        }

        if (fields.phone.length < 11){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را کامل وارد کنید!';
        }else if (fields.phone.length === 11){
            errors['phone'] = null;
        }

        this.setState({errors}, ()=>{
            return callback(formIsValid);
        });
    }

    handleRequest(){
        console.log("handleRequest")

        $('#waitspinner').modal('show');
        $('#progressTop').removeClass('invisible');
        $('#r_fab').addClass('invisible');

        const {namefamily,phone} = this.state.fields;
        const oldnamefamily = this.props.products['studentname'];
        const oldphone = this.props.products['studentphone'];

        let data = new FormData();
        data.append('id',this.props.products['id']);
        data.append('namefamily',namefamily);
        data.append('phone',phone);
        data.append('oldnamefamily',oldnamefamily);
        data.append('oldphone',oldphone);


        axios.post(Data.server+'editClassInfo.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');

                if (response.data === "ok") {

                    this.props.toast("ویرایش با موفقیت انجام شد",3000,"bg-success",()=> {
                        $('#liveToast').toast('show');
                    });

                    this.props.products['namefamily'] = namefamily;
                    this.props.products['phone'] = phone;
                    this.setState({
                        name: this.props.products['namefamily'],
                        phone: this.props.products['phone']
                    })
                    $('#'+this.props.classid+'namephone')[1].innerText = namefamily+ "\n"+ phone;

                }
                if (response.data.includes("error update")){
                    this.props.toast("خطای داخلی رخ داد",3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    });
                }

            })
            .catch(error=>{
                $('#progressTop').addClass('invisible');
                $('#r_fab').addClass('animate__animated animate__zoomIn');
                console.log(error);
            });
    }

    render() {
        const {id,classid,products,index} = this.props;

        const {namefamily , phone} = this.state.fields;
        const {errors} = this.state;

        return (
            <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={id+"Label"}
                                         aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id={id+"Label"}>{"ویرایش "+namefamily+" "+phone}</h6>
                            <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="login-form mx-auto">
                                <div className="form-group text-right">
                                    <label>نام نام خانوادگی</label>
                                    <input
                                        type="namefamily"
                                        className={["form-control", errors['namefamily'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="namefamily"
                                        value={namefamily}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا نام نام خانوادگی هنرجو را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['namefamily'] ? 'block':'none'}}>{errors['namefamily']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label>شماره تلفن</label>
                                    <input
                                        type="number"
                                        className={["form-control", errors['phone'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="phone"
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toString().slice(0, 11)
                                            e.target.value = e.target.value.replace(/\D/g, "")
                                        }}
                                        value={phone}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا شماره تلفن هنرجو را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['phone'] ? 'block':'none'}}>{errors['phone']}</span>

                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="btn-group">
                                <button type="submit" className="btn btn-info" onClick={this.handleSubmit.bind(this)} >تایید</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">لغو</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalEditClassInfo;
